import axios from "axios";

export default {
    namespaced: true,
    state: {
        cities: [],
        points: [],
        pointData: null
    },
    mutations: {
        setterCities(state, data) {
            state.cities = data;
        },
        setterPoints(state, data) {
            state.points = data;
        },
        setterPointData(state, data) {
            state.pointData = data;
        },
    },
    getters:{
        getCities(state) {
            return state.cities;
        },
        getPoints(state) {
            return state.points;
        },
        getPointData(state) {
            return state.pointData;
        }
    },
    actions: {
        async fetchCities(context) {
            try {
                await axios.get('/boxberry/cities').then((response) => {
                    context.commit('setterCities', response.data);
                });
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        async fetchPoints({ commit }, { city, lang }) {
            try {
                const response = await axios.get('/boxberry/points', {
                    params: { city, lang }
                });
                commit('setterPoints', response.data);
            } catch (e) {
                console.error('Error fetching Boxberry points:', e);
                throw e;
            }
        },
        async fetchPointData({ commit }, { code }) {
            try {
                const response = await axios.get('/boxberry/point-data', {
                    params: { code }
                });
                commit('setterPointData', response.data);
            } catch (e) {
                console.error('Error fetching Boxberry point:', e);
                throw e;
            }
        }
    }
};
